var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.23535,
    y: 2.35254,
    width: 10,
    height: 17.0588,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66228 0.587891H18.337C18.9023 0.587891 19.4114 1.09705 19.4114 1.66228V18.337C19.4114 18.9023 18.9023 19.4114 18.337 19.4114H1.66228C1.09705 19.4114 0.587891 18.9023 0.587891 18.337V1.66228C0.587891 1.09705 1.09705 0.587891 1.66228 0.587891ZM13.9554 11.1572H16.5554L16.6685 8.67023H13.9554V6.83346C13.9554 6.12715 14.0964 5.73103 15.0008 5.73103H16.5835L16.6404 3.41314C16.6404 3.41314 15.9341 3.30009 14.9167 3.30009C12.4297 3.30009 11.3273 4.8547 11.3273 6.52236V8.67023H9.49049V11.1572H11.3273V18.0531H13.9554V11.1572Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.73e38b33332bfb542aba1a456706983e.svg";
export { ForwardRef as ReactComponent };